import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

export const StatusBadge = ({
  color,
  statusText
}: {
  color: string;
  statusText: string;
}) => (
  <div
    className={`inline-block min-w-[70px] rounded px-[8px] text-center ${color} font-light`}
  >
    <p>{capitalizeFirstLetter(statusText.replace(/_/g, ' ').toLowerCase())}</p>
  </div>
);
